import { Context, Effect } from "effect";

export type IdGenerator = Readonly<{
	readonly randomUuid: Effect.Effect<string>;
}>;

/** UUID generation is overridable so Commands can be reproduced in tests. */
export const IdGenerator = Context.Reference<IdGenerator>(
	"rhysomn-client/app/IdGenerator",
	{
		defaultValue: () => ({
			randomUuid: Effect.sync(() => crypto.randomUUID()),
		}),
	},
);

export const randomUuid: Effect.Effect<string> = IdGenerator.pipe(
	Effect.flatMap((generator) => generator.randomUuid),
);
